import { useNavigate } from 'hooks/routes/useNavigate';
import { useCheckIndependentIraEmail } from 'hooks/api/independentIra';
import { useGetProfile } from 'hooks/api/login';
import SpecifyEmailModal from 'components/SpecifyEmailModal';
import { ModalProps } from 'components/Modal';
import { defaultAnnualFeeIraClubForIndependentIra } from '../IndependentIraForm/IndependentIraForm.const';

type Props = {
  onRequestClose: VoidFunction;
} & ModalProps;

const SpecifyEmail = ({ onRequestClose, ...props }: Props): JSX.Element => {
  const { mutateAsync: checkEmail } = useCheckIndependentIraEmail();
  const { data: profile } = useGetProfile();
  const { toIndependentIraNew } = useNavigate();

  const { defaultEtzFee, defaultCustodyFeePercentageIraClub } = profile || {};

  const callbackFn = async (email: string) => {
    const user = await checkEmail(email);

    toIndependentIraNew({
      ...user,
      annualFee: defaultAnnualFeeIraClubForIndependentIra,
      etzFee: defaultEtzFee,
      custodyFeePercentage: defaultCustodyFeePercentageIraClub,
    });
  };

  return (
    <SpecifyEmailModal
      callbackFn={callbackFn}
      onRequestClose={onRequestClose}
      {...props}
    />
  );
};

export default SpecifyEmail;
